import { defineStore } from 'pinia'
import {useAuthStore} from "@/stores/auth.js";

export const useSubscriptionStore = defineStore('subscription', {
    state: () => ({
        loading: false,
        error: null,
    }),
    actions: {
        async subscribe(priceId, email) {
            this.loading = true
            this.error = null

            let userToken = await useAuthStore().getUserToken();

            if (!userToken) {
                return new Response("User Token not found. Please log in.", { status: 401 });
            }

            try {
                let sessionId = crypto.randomUUID(); // Generate a unique session ID
                const res = await fetch(import.meta.env.VITE_BACKEND_API_URL + '/api/subscription/subscribe', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${userToken}`,
                    },
                    body: JSON.stringify({
                        priceId,
                        email,
                        successUrl: window.location.origin + '/premium/thank-you?session_id=' + sessionId,
                        cancelUrl: window.location.origin + '/premium/cancel',
                    }),
                })

                const data = await res.json()
                if (data.url) {
                    window.location.href = data.url
                } else {
                    throw new Error(data.error || 'Subscription failed')
                }
            } catch (err) {
                this.error = err.message
            } finally {
                this.loading = false
            }
        },

        // check if the user has an active subscription
        async checkSubscription() {
            this.loading = true
            this.error = null

            let userToken = await useAuthStore().getUserToken();

            if (!userToken) {
                return new Response("User Token not found. Please log in.", { status: 401 });
            }

            try {
                const res = await fetch(import.meta.env.VITE_BACKEND_API_URL + '/api/subscription/check', {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${userToken}`,
                    },
                })

                const data = await res.json()
                return data
            } catch (err) {
                this.error = err.message
                return null
            } finally {
                this.loading = false
            }
        },

        async openCustomerPortal(customerId) {
            this.loading = true
            this.error = null
            try {
                const res = await fetch('/api/subscription/create-portal', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        customerId,
                        returnUrl: window.location.origin,
                    }),
                })

                const data = await res.json()
                if (data.url) {
                    window.location.href = data.url
                } else {
                    throw new Error(data.error || 'Failed to open portal')
                }
            } catch (err) {
                this.error = err.message
            } finally {
                this.loading = false
            }
        },

        async isSubscribed() {
            this.loading = true
            this.error = null

            let userToken = await useAuthStore().getUserToken();

            if (!userToken) {
                return new Response("User Token not found. Please log in.", { status: 401 });
            }

            try {
                const res = await fetch(import.meta.env.VITE_BACKEND_API_URL + '/api/subscription/is-subscribed', {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${userToken}`,
                    },
                })

                const data = await res.json()
                return data.isSubscribed
            } catch (err) {
                this.error = err.message
                return false
            } finally {
                this.loading = false
            }
        }
    },

})
